<template>
  <div>
    <Modal v-model="visible" title="批量更新保单状态" :footer-hide="true" :mask-closable="false" class="my-modal top" width="600px">
      <div style="margin-top: 10px;">
        操作步骤：<br>
          1、在列表根据查询条件或使用【批量查询】搜索出需要更新状态的保单<br>
          2、点击【导出要修改的数据】，按照填写说明更新数据<br>
          3、将修改后的Excel导入系统<br>
          注意：<span style="color:#E3461F;">平台保单不支持手动更新，所有导入数据将自动过滤平台单，</span>单次导入最多1000条数据。<br>
      </div>

    <div class="ivu-modal-footer">
      <Button type="text" @click="exportData">导出要修改的数据</Button>
      <Upload
          ref="upload"
          :show-upload-list="false"
          class="upload-btn"
          :max-size="2048"
          :data="{}"
          :before-upload="handleBeforeUpload"
          action="/"
        >
      <Button type="primary" :loading="loading">导入修改后的Excel</Button>
    </Upload>
    </div>
  </Modal>
  </div>
</template>

<script>
export default {
  props:['initFilterObj'],
  data(){
    return{
      visible:false,
      fileFormat: ['xls', 'xlsx', 'XLS', 'XLSX'],
      loading: false,
    }
  },
  methods:{
    open(){
      this.visible = true
    },
    exportData(){
      this.$emit('getParams')
      this.$nextTick(()=>{
        this.$units.downloadFile('/buz/policy/policyExportByUpdate',this.initFilterObj,'POST');
      })
      
    },
    handleBeforeUpload(file) {
      const format = file.name.split('.')[1];
      if (!this.fileFormat.includes(format)) {
        this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      const params = {};
      if (params) {
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
            const element = params[key];
            formData.append(key, element);
          }
        }
      }
      this.loading = true;
      this.$notice.msg('正在上传文件，请稍等片刻');
      this.$http({
        type: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: '/buz/policy/policyImportByUpdate',
        data: formData,
      })
        .then(res => {
          console.log('res',res)
          if (res.httpCode==1) {
            if(res.data.errorList){

              const successNum = res.data.successList&&res.data.successList.length;
              const errorNum = res.data.errorList&&res.data.errorList.length;
              let text = `系统已成功更新${successNum}条数据`;
              if(errorNum){
                text = text+`，${errorNum}条数据导入失败，失败文件已自动下载`;
                  this.$units.downloadFile('/buz/policy/batchUpdate/exportError',{type:1,
                    errorList: res.data.errorList
                  },"POST")
                this.$notice.error(text)
              }else{
                this.visible = false;
                this.$notice.success(text)
              }
            }else{
              if(res.data.errorCount){
                if(res.data.errorList.length){
                  this.$units.downloadFile('/buz/policy/batchUpdate/exportError', {type:1},"GET",res.data.failFileName)
                }
                this.$notice.error(`系统已成功更新${res.data.successCount}条数据，${res.data.errorCount}条数据导入失败，失败文件已自动下载`)
              }else{
                this.visible = false;
                this.$notice.success(`系统已成功更新${res.data.successCount}条数据`)
              }
            }
            
          } else {
            const { data } = res;
            const reader = new FileReader();
            reader.onload = () => {
              const { result } = reader;
              const errorInfos = JSON.parse(result);
              const { msg } = errorInfos;
              this.$notice.error(msg);
            };
            reader.onerror = err => {
              reject(err);
            };
            reader.readAsText(data);
            this.$notice.hideLoading();
            this.visible = false;
          }
          this.$emit('toggleTab')
        }).finally((res) => {
          this.loading = false;
        });

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/{
  .ivu-btn{
    width: 150px!important;
  }
  .upload-btn{
    display: inline-block;
    margin-left: 20px;
  }
}
</style>